import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useIntl } from "react-intl";
import { useHistory, NavLink, useLocation } from "react-router-dom";
import {
  AppBar,
  Toolbar,
  makeStyles,
  IconButton,
  Tooltip,
} from "@material-ui/core";
import { ExitToApp } from "@material-ui/icons";
import translate from "i18n/translate";
import {
  AUTH_ROOT_ROUTE,
  REGISTER_ROUTE,
  FORGOT_PASSWORD_ROUTE,
  FORGOT_PASSWORD_SUBMIT_ROUTE,
  PHONE_VERIFICATION_ROUTE,
  LOGIN_ROUTE,
} from "routes/auth/authPaths";
import { authLogout } from "redux/auth/actions";
import { HEADER_HEIGHT } from "../../../constants";
import { SrButton, SrMainLogo } from "../../common";

const SHOW_REGISTER_ROUTES = [
  FORGOT_PASSWORD_ROUTE,
  FORGOT_PASSWORD_SUBMIT_ROUTE,
  LOGIN_ROUTE,
];

const useStyles = makeStyles((theme) => ({
  createAccount: {
    color: theme.palette.primary.contrastText,
  },
  toolbar: {
    height: HEADER_HEIGHT,
    paddingLeft: theme.spacing(3),
  },
}));

const Header = () => {
  const classes = useStyles();
  const history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();
  const [hasRegister, setHasRegister] = useState(false);
  const intl = useIntl();

  const isFromKonfio = () => {
    const ref = document.referrer;
    return !!(ref && ref.match(/^https?:\/\/?konfio\.mx(\/|$)/i));
  };

  const goToRegister = () => {
    const code = isFromKonfio() ? "/konfio" : "";
    history.push(AUTH_ROOT_ROUTE + REGISTER_ROUTE + code);
  };

  useEffect(() => {
    setHasRegister(
      !!SHOW_REGISTER_ROUTES.find((withRegisterRoute) =>
        location.pathname.includes(withRegisterRoute)
      )
    );
  }, [location]);

  const handleLogout = () => {
    dispatch(authLogout());
    history.push(AUTH_ROOT_ROUTE + LOGIN_ROUTE);
  };

  return (
    <AppBar position="fixed" elevation={0}>
      <Toolbar className={classes.toolbar}>
        <NavLink to="/">
          <SrMainLogo />
        </NavLink>
        {hasRegister && (
          <SrButton
            color="secondary"
            onClick={goToRegister}
            className={classes.createAccount}
          >
            {translate(`auth.createAccount`)}
          </SrButton>
        )}
        {location.pathname === AUTH_ROOT_ROUTE + PHONE_VERIFICATION_ROUTE && (
          <Tooltip title={intl.formatMessage({ id: "header.logout" })}>
            <IconButton color="inherit" onClick={handleLogout}>
              <ExitToApp />
            </IconButton>
          </Tooltip>
        )}
      </Toolbar>
    </AppBar>
  );
};

export default Header;
